import * as React from "react";
import { DealsDebugProps } from "components/flexComponents/Deals/typings";

export const DealsDebugInfo = (props: DealsDebugProps) => {
  const { queryResult, campaignId } = props;

  return (
    <div className="all-y-padding-two" data-testid="deals-debug-info">
      {
        <div data-testid="deals-debug-info-campaign-id">
          <strong>Campaign ID:</strong> {campaignId ?? "Not available."}
        </div>
      }
      {queryResult?.traceId && (
        <div data-testid="deals-debug-info-trace-id">
          <strong>Trace ID:</strong> {queryResult?.traceId}
        </div>
      )}
      {queryResult?.errorMessage && (
        <div data-testid="deals-debug-info-error-message">
          <strong>Error Message:</strong> {queryResult?.errorMessage}
        </div>
      )}
      {queryResult?.campaign?.offers && (
        <div data-testid="deals-debug-offer-count">
          <strong>Offer/Destination count:</strong> {queryResult?.campaign?.offers?.length}
        </div>
      )}
    </div>
  );
};
